import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { RumInit } from '@maersk-global/telemetry-web-sdk';
import { environment } from './environments/environment';

  const appName = environment.rumConfig.appName
  const apiKey = environment.rumConfig.apiKey
  const env = environment.rumConfig.appName.split("-")[1]
  RumInit({
    app: {
      environment: env,
      name: appName,
      version: "1.0.0",
    },
    apiKey: apiKey,
    debug: false,
    traceLog: true,
    useSendBeacon: true,
    propagateTraceHeaderCorsUrls: [/https?:\/\/.*/]
  });

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
